// generated by genversion
export var version = '4.7.12';
//# sourceMappingURL=version.js.map